module.exports = __webpack_public_path__ + "f7c7c075e861cd46f7cc0569a818e6e3.png";